// INSIDO: this module is the single point of truth for white-label branding.
// Everything brand-related in the client must reference these values instead
// of hardcoding a product name, logo path, colour or link.
//
// To re-skin the product when the final brand exists:
//   1. Edit the values below.
//   2. Replace the asset files in `scripts/assets_fallback/web/`
//      (wordmark.svg, monochrome.svg, icon.ico, android-chrome-*.png,
//      masking-512x512.png) keeping the same file names.
// Nothing else needs to change. See `.insido/DONE.md` for details.

export const BRANDING = {
  /**
   * Product name shown across the UI, page title and PWA manifest
   */
  productName: "Insido",

  /**
   * Short description used in the PWA manifest and meta tags
   */
  productDescription: "Comunicação empresarial para equipas.",

  /**
   * Public source code of our forks (AGPL §13 obligation)
   */
  sourceCodeUrl: "https://github.com/insido-chat",

  /**
   * Where to direct feature suggestions and feedback
   */
  feedbackUrl: "https://github.com/insido-chat",

  /**
   * In-app legal document routes (served by the client itself)
   */
  legal: {
    terms: "/legal/terms",
    privacy: "/legal/privacy",
    acceptableUse: "/legal/aup",
  },

  /**
   * Default theme seed (insido palette, keeps dark/light)
   */
  theme: {
    /**
     * Seed colour for the Material 3 palette.
     * INSIDO: the insido interactive accent (`--accent` in the prototype). The
     * full neutral surface ramp is overridden explicitly — see
     * components/ui/themes/insidoTheme.ts.
     */
    accent: "#3c7de6",
    /**
     * Default Material 3 scheme variant ("neutral" = desaturated, professional)
     */
    variant: "neutral" as const,
  },

  /**
   * INSIDO: the four insido brand colours (07-tema-insido). Single point of
   * truth, reused as presence colours and by message "marks" (module 08).
   * Light/dark variants live in components/ui/themes/insidoTheme.ts; these are
   * the canonical (dark-theme) values.
   */
  brandColors: {
    red: "#ec6359",
    amber: "#f2b550",
    green: "#4cb878",
    blue: "#5a93ec",
  },

  /**
   * Manifest / splash colours
   */
  themeColor: "#111111",
};
